import { Button, FilledInput, FormControl, TextField } from '@mui/material';
import { styled } from '@mui/system';

export const IntakeWrapper = styled('div')();

export const IntakeContentWrapper = styled('div')({
  background: 'var(--new-peony-50)',
  display: 'flex',
  justifyContent: 'center',
  minHeight: '100vh',
});

export const IntakeLoginContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  maxWidth: '744px',
  width: '100%',
  margin: '57px 0',
  background: 'var(--new-neutral-tertiary)',
  '@media (max-width:744px)': {
    margin: 0,
  },
  '.header-container': {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    '.header-banner': {
      display: 'flex',
      margin: '15px',
      padding: '127px 0px',
      borderRadius: '3px',
      justifyContent: 'center',
      '@media (max-width:744px)': {
        margin: '0 0 15px 0',
        borderRadius: 0,
        padding: '174px 0px 97px',
      },
      '@media only screen and (max-width: 480px)': {
        padding: '88px 0px 66px',
      },
      svg: {
        width: '192px',
        height: '98px',
        '@media only screen and (max-width: 480px)': {
          width: '105px',
          height: '54px',
        },
      },
    },
    '.header-wrapper': {
      display: 'flex',
      gap: '8px',
      justifyContent: 'center',
      flexDirection: 'column',
      paddingTop: '13px',
      '&.forgot-password-wrapper': {
        paddingTop: '44px',
      },
      '&.signup-wrapper': {
        paddingTop: '44px',
        paddingBottom: '8px',
      },
      '@media only screen and (max-width: 480px)': {
        gap: '12px',
        padding: '0 24px',
      },
    },
  },
  '.login-container': {
    display: 'flex',
    padding: '32px 78px 33px',
    justifyContent: 'center',
    flexDirection: 'column',
    '@media only screen and (max-width: 480px)': {
      padding: '24px 24px 34px',
    },
  },
  '.header': {
    textAlign: 'center',
    color: 'var(--new-navy)',
    fontFamily: 'var(--new-font)',
    fontStyle: 'normal',
    fontWeight: 300,
    '@media (max-width:744px)': {
      fontSize: '40px',
      lineHeight: '48px',
    },
    '@media only screen and (max-width: 480px)': {
      fontSize: '32px',
      lineHeight: '40px',
    },
  },
  '.title': {
    textAlign: 'center',
    color: 'var(--new-navy)',
    fontFamily: 'var(--new-font)',
    fontStyle: 'normal',
    fontWeight: 300,
    '&.forgot-password-title': {
      maxWidth: '384px',
      margin: '0 auto',
    },
  },
  '.input-field': {
    paddingBottom: '24px',
  },
  '.forgot-container': {
    '.input-field': {
      paddingTop: '8px',
      paddingBottom: '40px',
      label: {
        paddingTop: '8px',
      },
    },
  },
  '@media (max-width:501px)': {
    paddingTop: '16px',
    paddingBottom: '40px',
  },
  '@media only screen and (max-width: 480px)': {
    padding: 0,
  },
  '.link': {
    color: 'var(--new-navy)',
    textDecorationColor: 'var(--new-navy)',
    fontFamily: 'var(--new-font)',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '24px',
    width: 'fit-content',
  },
  '.input-button': {
    marginTop: '32px',
    padding: '16px 40px',
    '&.signup-button': {
      marginTop: 0,
    },
    '@media only screen and (max-width: 480px)': {
      marginTop: '24px',
      marginBottom: '16px',
    },
    span: {
      fontFamily: 'var(--new-font)',
    },
  },
  '.signup-link': {
    fontFamily: 'var(--new-font)',
    fontStyle: 'normal',
    fontWeight: 300,
    color: 'var(--new-navy)',
    '.link': {
      fontWeight: 400,
    },
  },
  '.custom-padding': {
    paddingBottom: '24px',
  },
});

export const IntakeFooterWrapper = styled('div')({
  backgroundColor: 'var(--neutral-tertiary)',
  minHeight: '460px',
  display: 'flex',
  justifyContent: 'center',

  '.intake-icon-wrapper': {
    display: 'flex',
    justifyContent: 'space-center',
    minWidth: '588px',
  },
  '.seeds-icon': {
    zIndex: '1',
    right: '80px',
    position: 'relative',
  },
  '.lake-icon': {
    right: '10%',
    position: 'absolute',
    bottom: '5%',
  },

  '.slice-icon': {
    position: 'absolute',
    bottom: '0',
  },

  '@media (max-width:880px)': {
    '.seeds-icon': { right: '40px' },
    '.lake-icon': { right: '-5%', top: '77%' },

    '.slice-icon': {
      left: '9%',
      top: '80%',
    },
  },
  '@media (max-width:501px)': {
    position: 'relative',
    marginTop: '6px',
    minHeight: 'unset',
    '.seeds-icon': { right: '0px' },
    '.lake-icon': { right: '-10%', top: '64px' },

    '.slice-icon': {
      display: 'none',
    },
    '.intake-icon-wrapper': {
      minWidth: '425px',
    },
  },
});

export const StyledFilledTextField = styled(TextField)({
  '.MuiFilledInput-root': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 20px',
    gap: '4px',
    backgroundColor: 'var(--neutral-secondary) !important',
    borderRadius: '8px',
    border: '1px solid var(--neutral-secondary-darker)',
    color: 'var(--neutral-primary)',
    fontSize: '16px',
    height: '64px',
    '&.Mui-error': {
      border: '1px solid var(--negative-primary)',
    },
  },
  '.MuiFilledInput-input': {
    padding: '0px',
    paddingTop: '16px',
  },
  '& .MuiFilledInput-root:before , & .MuiFilledInput-root:after , & .MuiFilledInput-root:hover:before , & .MuiFilledInput-root:hover:not(.Mui-disabled):before':
    {
      border: 'none',
    },
  '& label.Mui-focused': {
    textTransform: 'capitalize',
    color: 'var(--neutral-primary-light)',
  },
  '.MuiInputLabel-root': {
    fontSize: '16px',
    fontFamily: 'var(--new-font)',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '24px',
    color: 'var(--neutral-primary-light)',
    paddingLeft: '10px',
    transform: 'translate(12px, 20px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transition: 'none',
      transform: 'translate(10px, 10px) scale(1)',
      textTransform: 'uppercase !important',
      fontWeight: 400,
      lineHeight: '16px',
    },
    '&[data-shrink="true"]': {
      textTransform: 'capitalize',
      fontSize: '12px',
      letterSpacing: '0.03em',
      '&.Mui-error': {
        color: 'var(--neutral-primary-light)',
      },
    },
  },

  '.MuiFormHelperText-root': {
    margin: '0px',
    marginTop: '8px',
    '&.Mui-error': {
      color: 'var(--negative-primary)',
    },
    '.char-limit': {
      fontFamily: 'var(--new-font)',
      fontStyle: 'normal',
      fontWeight: 300,
      color: 'var(--new-navy)',
    },
  },
});

export const StyledIconButton = styled(Button)({
  fontFamily: 'var(--new-font)',
  fontStyle: 'normal',
  fontWeight: 300,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px 12px',
  gap: '8px',
  textTransform: 'none',
  margin: '16px 0px 0px 14px',
  '&:hover': {
    background: 'transparent',
  },
  p: {
    fontFamily: 'var(--new-font)',
    fontStyle: 'normal',
    fontWeight: 300,
    color: 'var(--new-navy)',
  },
  '.MuiButton-startIcon': {
    margin: '0px',
  },
});

export const StyledPasswordTextInput = styled(FilledInput)({
  backgroundColor: 'var(--neutral-secondary)!important',
  border: 'none',
  borderRadius: '8px',
  color: 'var(--neutral-primary-light)',
  ':before,:after,:hover:before,:hover:not(.Mui-disabled):before': {
    borderBottom: 'none',
  },
  input: {
    borderRadius: '8px',
  },
});

export const StyledFormControl = styled(FormControl)({
  '& .MuiInputLabel-root': {
    color: 'var(--neutral-primary-light)',

    '&[data-shrink="true"]': {
      textTransform: 'uppercase',
      color: 'var(--neutral-primary-light)',
    },
  },
  '.MuiInputLabel-root.Mui-focused': {
    color: 'var(--neutral-primary-light)',
  },
  '.MuiFormHelperText-root': {
    margin: '0px',
    marginTop: '8px',
    '&.Mui-error': {
      color: 'var(--negative-primary)',
    },
  },
  '.MuiIconButton-root': {
    padding: '20px',
  },
});
